<template>
    <div class="flex h-full overflow-hidden">
        <reports-menu 
            :report-data="reportData"
            @category-selected="handleCategorySelected"
        />
        <reports 
            :report-data="reportData"
            :selected-category="selectedCategory"
        />
    </div>
</template>

<script>
import ReportsMenu from './ReportsMenu.vue';
import Reports from './Reports.vue';

export default {
    name: 'ReportsPage',
    
    components: {
        ReportsMenu,
        Reports
    },

    props: {
        reportData: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            selectedCategory: ''
        };
    },

    methods: {
        handleCategorySelected(categoryId) {
            this.selectedCategory = categoryId;
        }
    }
};
</script>
